import $ from 'wee-dom';
import $events from 'wee-events';
import infoboxTemplate from './infobox-template';

export default class {
    constructor(sel = ':map') {
       this.map = new google.maps.Map($(sel)[0], {
            center: {
                lat: 30.6804215,
                lng: -88.0398912,
            },
            mapTypeControl: false,
            streetViewControl: false,
            zoom: 11
        });
        this.markers = [];
        this.activeWindow = null;
    }

    setMarkers(elements) {
        this.setMapOnAll(null);
        this.markers = [];
        this.activeWindow = null;

        elements.forEach(el => this.createMarker(el));
        return this;
    }

    setMapZoom(zoom) {
        this.map.setZoom(zoom);
    }

    createMarker(location) {
        // make marker
        let marker = this.addMarker(location);
        this.markers.push(marker);

        // make info window
        const infoWindow = this.createInfoWindow(location);

        // marker events
        marker.addListener('click', (e) => {
            this.closeInfoWindow();
            infoWindow.open(this.map, marker);
            this.activeWindow = infoWindow;
        });

        $events.on(location.selector, 'click', (e, el) => {
            if (! e.target.href) {
                this.closeInfoWindow();
                infoWindow.open(this.map, marker);
                this.map.setCenter(new google.maps.LatLng(location.data.lat, location.data.lng));
                this.map.setZoom(13);
                this.activeWindow = infoWindow;
            }
        });
    }
    
    closeInfoWindow() {
        if (this.activeWindow) {
            this.activeWindow.close();
        }
    }

    addMarker(location) { 
        return new google.maps.Marker({
            position: {
                lat: parseFloat(location.data.lat),
                lng: parseFloat(location.data.lng)
            },
            title: location.title,
            map: this.map
        });
    }

    setMapOnAll(map) {
        for (var i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    }

    createInfoWindow(el) {
        return new google.maps.InfoWindow({
            content: infoboxTemplate({
                title: el.data.title,
                url: el.url,
                address: el.address,
                phone: el.phone,
                directions: `https://www.google.com/maps/search/?api=1&query=${el.data.lat},${el.data.lng}`
            })
        });
    }
}
